import { Chain } from '@starsoft/common/models';
import { FCInputProp } from '../../props';
import styles from './styles.module.scss';
import { useTranslation } from '../../../../hooks';
import { getContrastColor } from '@starsoft/common/utils';

/**
 * Component that renders a custom input for selecting blockchain chains
 * Displays the chain name, symbol and color with a dropdown toggle
 *
 * @param {Object} props - Component props
 * @param {Chain} props.option - The currently selected chain option
 * @param {Function} props.handleOpen - Callback function to handle opening/closing the dropdown
 * @param {boolean} props.open - Whether the dropdown is currently open
 * @param {boolean} props.disabled - Whether the input is disabled
 * @returns {JSX.Element} Chain input component with name, colored chip and dropdown arrow
 */
export function ChainInput({
  option,
  handleOpen,
  open,
  disabled,
}: Omit<FCInputProp<Chain>, 'key'>) {
  const { t } = useTranslation('common');

  return (
    <div
      className={`${styles.container} ${disabled ? styles['container--disabled'] : ''}`}
      onClick={handleOpen}
    >
      <div className={styles.container__title}>
        {option?.name}{' '}
        <div
          className={styles.container__chip}
          style={{
            backgroundColor: option?.color,
            color: getContrastColor(option?.color),
          }}
        >
          {option?.symbol}
        </div>
      </div>
      <i
        className={open ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'}
      />
    </div>
  );
}
